<h2 matDialogTitle>Crop Image</h2>

<mat-dialog-content>
  <mgd-dialog-content-container>
    <mgd-image-cropper
      [imageSource]="data.imageSource"
      [internalCropWidth]="internalCropWidth"
      [internalCropHeight]="internalCropHeight"
      [lockDimensions]="lockDimensions"
      [hideSetDimensions]="hideSetDimensions"
      [mimeType]="mimeType"
      (crop)="onCrop($event)" />
  </mgd-dialog-content-container>
</mat-dialog-content>

<mat-dialog-actions>
  @if (data.removeLabel) {
    <button id="mat-image-cropper-dialog-remove-button" mgdButton mgdButtonType="caution" mat-raised-button type="button"
            (click)="onRemoveClick()">{{ data.removeLabel }}</button>
  }
  <button id="mat-image-cropper-dialog-cancel-button" mgdDialogCloseButton mat-raised-button
          type="button">Cancel</button>
  <button id="mat-image-cropper-dialog-crop-button" mgdButton mgdButtonType="save" mat-raised-button type="button"
          (click)="onCropClick()">Crop</button>
</mat-dialog-actions>
